import { render, staticRenderFns } from "./TakeBackRecord.vue?vue&type=template&id=225427bd&scoped=true&"
import script from "./TakeBackRecord.vue?vue&type=script&lang=ts&"
export * from "./TakeBackRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225427bd",
  null
  
)

export default component.exports